import { SEARCH_DEFAULT_PAGE_SIZE } from '../../../../constants/person-constants';
import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/person`;

const req = (opts) => request({ ...opts, throw400Error: true });

/**
 * @param {{ q: string, page?: number, pageSize?: number }} params
 * @returns {Promise<{ results: Array, page: number, pageSize: number, totalCount: number, totalPages: number }>}
 */
export function searchPersons({ q, page = 1, pageSize = SEARCH_DEFAULT_PAGE_SIZE }) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    q: q || '',
  });
  return req({ url: `${BASE}/search?${qs.toString()}`, method: 'GET' });
}

/** @returns {Promise<Array<{ id: number, name: string, description: string|null }>>} */
export function getAttributeTypes() {
  return req({ url: `${BASE}/attribute-types`, method: 'GET' });
}

/** @returns {Promise<Array>} */
export function getPersonAttributes(personId) {
  return req({ url: `${BASE}/${encodeURIComponent(personId)}/attributes`, method: 'GET' });
}

export function createPersonAttribute(personId, body) {
  return req({
    url: `${BASE}/${encodeURIComponent(personId)}/attributes`,
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updatePersonAttribute(personId, assnId, body) {
  return req({
    url: `${BASE}/${encodeURIComponent(personId)}/attributes/${encodeURIComponent(assnId)}`,
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deletePersonAttribute(personId, assnId) {
  return req({
    url: `${BASE}/${encodeURIComponent(personId)}/attributes/${encodeURIComponent(assnId)}`,
    method: 'DELETE',
  });
}
